let baseURL = ''
if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://menxia.co/api/v1' // Production URL that client will make its requests, use api to differentiate web routing and call for the server back-end.
} else {
  baseURL = 'http://localhost:8081/api/v1' // Development URL that client will make its requests, use api to differentiate web routing and call for the server back-end.
}
export default {
  baseURL: baseURL,
  version: 'admin_1.03', // version will be stored on the user side to identify the corresponding version number of use's stored data. If the data structure in "store" is changed, version number must be updated -- this will trigger an forced login to update stored data on the client side.
  imageMaxSizePx: 1080 // the maximum size of image uploaded to aliOss
}
